import React from 'react'
import { oneOf } from 'prop-types'
import { capitalize } from 'lodash'
import className from 'classnames'

class DashboardDropdown extends React.Component {
  static propTypes = {
    scope: oneOf(['daily', 'weekly', 'monthly'])
  }

  static defaultProps = {
    scope: 'daily'
  }

  state = {
    isActive: false,
  }

  render = () => {
    return (
      <div
        className={className('DashboardDropdown', {
          'ClickOpenPanel': true,
          'ClickOpenPanel--active': this.state.isActive,
        })}
      >
        <h2 className='MainHeader__h2 '>
          <a
            onClick={() => {
              this.setState((prevState) => ({
                isActive: !prevState.isActive,
              }))
            }}
          >
            {capitalize(this.props.scope)} reports
          </a>
        </h2>

        {(() => {
          const data = [
            {label: 'Daily', href: '?scope=daily'},
            {label: 'Weekly', href: '?scope=weekly'},
            {label: 'Monthly', href: '?scope=monthly'},
          ]

          return (
            <ul className='ClickOpenPanel__panel'>
              {data.map((x, i) => (
                <li key={i}>
                  <a
                    className={className('ClickOpenPanel__panel__a', {
                      'ClickOpenPanel__panel__a--active': true,
                    })}
                    href={`${x.href}`}
                  >
                    {x.label}
                  </a>
                </li>
              ))}
            </ul>
          )
        })()}
      </div>
    )
  }
}

export default DashboardDropdown
